module.exports = __webpack_public_path__ + "images/emoji/arrow_up_small.5915edb2fc574e33aa6d.png";